import { useContext } from "react";

import { SmartParseContext } from "../../contexts/super/SmartParseContext";

const useSmartParse = () => {
  const context = useContext(SmartParseContext);
  return context;
};

export default useSmartParse;
